import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const Foundation = ({ onFoundationSelected }) => {
  const [SelectedFoundation, setSelectedFoundation] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.foundation) {
        const foundationObject = firstResult.foundation;
        if (foundationObject.trim() !== "") {
          setVariations(foundationObject.split(","));
        } else {
        }
      } else {
      }
    } catch (error) {
      // console.error("Error fetching product variations:", error);
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  //get variation selected and send it to the cart
  const handleColorClick = (size) => {
    setSelectedFoundation(size);
    onFoundationSelected(size);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Foundation:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${SelectedFoundation === variation ? "selected" : ""}`}
            onClick={() => handleColorClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default Foundation;
